import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"
import { UserMenuJson } from "../models/models"

export class SaveAdminUserMenuApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, userId: number) {
    super({
      url: `admin/admin-menu/user-view/${userId}`,
      requesterInfo,
    })
  }

  public async SaveAdminUserMenuApi(payload: UserMenuJson): Promise<UserMenuJson> {
    return await this.postAsync<UserMenuJson>(payload)
  }
}
